// extracted by mini-css-extract-plugin
module.exports = {"component":"CmsRepairTimes_component__t7uWE","boxed":"CmsRepairTimes_boxed__qh8iy"};